import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('invalid');
      return;
    }
    const verify = async () => {
      try {
        await API.get(`/auth/verify-email?token=${token}`);
        setStatus('success');
        setTimeout(() => navigate('/'), 3000);
      } catch (err) {
        setStatus('invalid');
      }
    };
    verify();
  }, []);

  return (
    <div style={styles.container} className="container">
      <div style={styles.card}>
        {status === 'verifying' && (
          <>
            <div style={styles.spinner}></div>
            <h2 style={styles.title}>Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={styles.title}>Email Verified!</h2>
            <p style={styles.subtitle}>Your account is now active. Redirecting to login...</p>
          </>
        )}
        {status === 'invalid' && (
          <>
            <div style={styles.icon}>❌</div>
            <h2 style={styles.title}>Invalid Link</h2>
            <p style={styles.subtitle}>This verification link is invalid or has expired.</p>
            <button onClick={() => navigate('/')} style={styles.button}>Go to Login</button>
          </>
        )}
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', textAlign: 'center' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 1rem' },
  icon: { fontSize: '48px', marginBottom: '1rem' },
  title: { fontSize: '22px', marginBottom: '0.5rem' },
  subtitle: { color: '#888', fontSize: '14px', marginBottom: '1rem' },
  button: { padding: '10px 24px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
};

export default VerifyEmail;